const lang = {
  contact: 'Contact',
  experience: 'Ervaringen',
  education: 'Opleidingen',
  skills: 'Skills',
  about: 'Over mij'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/nl.js